import { useRef, useState, useEffect, cloneElement, ReactElement } from "react";
import { Popover } from "antd";

interface EllipsisPopoverProps {
  title: string;
  children: ReactElement;
}

const EllipsisPopover = ({ title, children }: EllipsisPopoverProps) => {
  const ref = useRef<HTMLElement>(null);
  const [isOverflow, setIsOverflow] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (el) {
      setIsOverflow(el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight);
    }
  }, [title]);

  return (
    <Popover title={title} open={isOverflow ? undefined : false}>
      {cloneElement(children, { ref })}
    </Popover>
  );
};

export default EllipsisPopover;
